<div 
    class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4 overflow-y-auto"
    (click)="$event.preventDefault(); handleCloseStudentInfo();"
>
    <div class="w-full max-h-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="w-full flex min-w-full h-full overflow-y-auto bg-white p-10 rounded-md text-center shadow-lg">
            <form 
                (ngSubmit)="$event.preventDefault(); saveStudentInfo();"
                [formGroup]="studentInfoForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >
                <div class="w-full flex flex-col gap-2 items-center justify-center pb-4 border-b border-orange-200">
                    <div class="w-full flex gap-2 items-center justify-between">                        
                        <h2 class="w-full text-[#f15f3e] oswald-font text-xl font-medium text-start">
                            No Behavioral Threat Assessments Identified.
                        </h2>
                        <button
                            class="p-1 rounded-full hover:bg-gray-100"
                            (click)="$event.preventDefault(); handleCloseStudentInfo();"
                        >
                            <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                        </button>
                    </div>
                    <p class="w-full text-start">
                        Please fill out the information below to continue with this Behavioral Threat Assessment.
                    </p>
                </div>
                <div class="w-full flex flex-col items-center gap-2 pb-4 border-b border-orange-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>SSID:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="student_identifier"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                            <!-- <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="eventForm.get('name')?.invalid && (eventForm.get('name')?.touched || eventForm.get('name')?.dirty)"
                            >
                                <div *ngIf="eventForm.get('name')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>First Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="first_name"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., John"
                            >
                            <!-- <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="eventForm.get('name')?.invalid && (eventForm.get('name')?.touched || eventForm.get('name')?.dirty)"
                            >
                                <div *ngIf="eventForm.get('name')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Last Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="last_name"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., Doe"
                            >
                            <!-- <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="eventForm.get('name')?.invalid && (eventForm.get('name')?.touched || eventForm.get('name')?.dirty)"
                            >
                                <div *ngIf="eventForm.get('name')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Date of Birth:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <div class="w-full relative">
                                <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                    </svg>
                                </div>
                                <input id="datepicker-birthdate" #datepickerBirthdate name="birthday" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Grade:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="grade"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            >
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Gender:</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="male" value="male" class="hidden peer"
                                    formControlName="identified_gender"
                                >
                                <label for="male"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Male
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="female" value="female" class="hidden peer"
                                    formControlName="identified_gender"
                                >
                                <label for="female"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Female
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="other" value="other" class="hidden peer"
                                    formControlName="identified_gender"
                                >
                                <label for="other"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Other
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-start text-start">
                        <div class="w-52 flex items-center">
                            <p>Physical Description:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea 
                                formControlName="physical_description"
                                rows="3"
                                class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                placeholder="Physical Description..."
                            ></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Does the student have an IEP?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_iep_yes" value="1" class="hidden peer"
                                    formControlName="has_iep">
                                <label for="has_iep_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_iep_no" value="0" class="hidden peer"
                                    formControlName="has_iep">
                                <label for="has_iep_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="studentInfoForm.get('has_iep')!.value === this.yesNo.Yes" class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>IEP Contacts (email address):</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input 
                                type="text"
                                formControlName="iep_contact"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., johndoe@test.com, janedoe@test.com, ..."
                            >
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Does the student have an IHP?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_ihp_yes" value="1" class="hidden peer"
                                    formControlName="has_ihp"
                                >
                                <label for="has_ihp_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_ihp_no" value="0" class="hidden peer"
                                    formControlName="has_ihp"
                                >
                                <label for="has_ihp_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-52 flex items-center">
                            <p>Does the student have a 504?</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="has_504_yes" value="1" class="hidden peer"
                                    formControlName="has_504"
                                >
                                <label for="has_504_yes"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Yes
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="has_504_no" value="0" class="hidden peer"
                                    formControlName="has_504"
                                >
                                <label for="has_504_no"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); handleCloseStudentInfo();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="flex items-center justify-center px-2.5 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.studentInfoForm.invalid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.studentInfoForm.valid
                        }"
                        [disabled]="studentInfoForm.invalid"
                    >
                        Save and Proceed to Creating New Assess Case
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>